export const PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT = 'aud_desktop_bx775_saved_search_favorites_merge';

export const EXPERIMENTS = [PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT];
